module.exports = __webpack_public_path__ + "img/mondrian.f8511f3.webp";